import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { configureCompetitors, getCompetitors, refreshCompetitors, updateCompetitorTracking } from "../../api/bReviewsApi";

export function useCompetitors(params) {
  return useQuery({
    queryKey: ["review-competitors", params],
    queryFn: () => getCompetitors(params),
    enabled: Boolean(params?.organisationId && params?.locationId),
    staleTime: 5 * 60 * 1000,
  });
}

export function useConfigureCompetitors() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: configureCompetitors,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["review-competitors"] }),
  });
}

export function useRefreshCompetitors() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: refreshCompetitors,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["review-competitors"] }),
  });
}

export function useUpdateCompetitorTracking() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ competitorId, ...data }) => updateCompetitorTracking(competitorId, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["review-competitors"] }),
  });
}
